export class NetworkError extends Error {
    public name = 'NetworkError';
}
